export enum UserProviderType {
  GOOGLE = "google",
  APPLE = "apple",
  PHONE = "phone",
  GUEST = "guest",
}
